import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("slideShowImage3", component(opts));
  editor.BlockManager.add("slideShowImage3", block(opts));
};